export const CERTIFICATE_APPROVAL_STATUS = {
    PENDING: "PENDING",
    PENDING_COORDINATOR_SIGNATURE: "PENDING_COORDINATOR_SIGNATURE",
    COORDINATOR_SIGNED: "COORDINATOR_SIGNED",
    COMPLETED: "COMPLETED",
    APPROVED: "APPROVED",
    COMPLETE: "COMPLETE",
};

const getStatus = (course) =>
    String(course?.certificateApprovalStatus || "").trim().toUpperCase();

// Trainer approval actions require the coordinator's signature first.
export const isCertificateApprovalPending = (course) =>
    getStatus(course) === CERTIFICATE_APPROVAL_STATUS.COORDINATOR_SIGNED;

export const isCertificatePendingCoordinatorSignature = (course) =>
    [CERTIFICATE_APPROVAL_STATUS.PENDING,
        CERTIFICATE_APPROVAL_STATUS.PENDING_COORDINATOR_SIGNATURE].includes(getStatus(course));

export const isCertificateApprovalComplete = (course) =>
    [CERTIFICATE_APPROVAL_STATUS.COMPLETED,
        CERTIFICATE_APPROVAL_STATUS.APPROVED,
        CERTIFICATE_APPROVAL_STATUS.COMPLETE].includes(getStatus(course));

export const isCertificateUnapproved = (course) =>
    Boolean(course) && !isCertificateApprovalComplete(course);

export const TRAINEE_STATUS_FILTERS = [
    {id: "FAIL", name: "Fail"},
    {id: "PENDING", name: "Pass/Pending"},
    {id: "COMPLETED", name: "Completed"},
    {id: "UNCOMPLETED", name: "Uncompleted"},
];

export const traineeStatusQuery = (status, {failId} = {}) => {
    if (status === "FAIL") return `&statusId=${Number(failId) || -1}`;
    if (status === "PENDING") return "&certificateStatus=PENDING";
    if (status === "COMPLETED") return "&certificateStatus=COMPLETED";
    if (status === "UNCOMPLETED") return "&statusId=0";
    return "";
};
